
export const SUBSCRIBED = {
    0: '已添加自选',
    1: '已添加自選',
    2: 'Subscribed',
    5: 'Subscribed',
    6: 'Subscribed',
};

export const UNSUBSCRIBED = {
    0: '已取消',
    1: '已取消',
    2: 'Unsubscribed',
    5: 'Unsubscribed',
    6: 'Unsubscribed'
};
